import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { clients, Iresult, ProcessRunService } from "../shared/process-run.service";
import { MatDialog } from "@angular/material/dialog";
import { ResultComponent } from "../result/result.component";

@Component({
  selector: "app-process-run",
  templateUrl: "./process-run.component.html",
  styleUrls: ["./process-run.component.css"],
})
export class ProcessRunComponent implements OnInit {
  appp = "";
  currentProcessing = "";
  percent =0;
  count = 0;
  allowRun: boolean = true;
  clients: clients[] = [];
  selectedClie: clients[] = [];
  done: clients[] = [];
  failed: clients[] = [];
  resultData: Iresult[] = [];

  disable = false;
  loadNewresult(obj: Iresult) {
    this.resultData.map((e) => {
      if (e.clientID == obj.clientID) {
        e.msg = obj.msg,
          e.success = obj.success,
          e.VisualisationFileName = obj.VisualisationFileName
      }
    })
    this.processSer.fetchNewRes.emit(true);
  }


  decideSuccess(mode, resp) {

    if (mode == 'success') {

      if (this.appp == 'auc') {
        if (resp.Success || resp.success) {
          return true;
        } else {
          return false;

        }
      } else { // for anc
        if (resp.Success || resp.success) {
          return true;
        } else {
          return false;
        }
      }

    } else {
      if (this.appp == 'auc') {
        if (resp?.error == true) {
          return true;
        }
        return false;
      }
      return false;
    }
  }
  visualFIlenameExtractor(respObj: any) {
    if (respObj) {
      if (respObj.VisualisationFileName) {

        return respObj.VisualisationFileName;
      } else if (respObj.visualisationFileName) {

        return respObj.visualisationFileName;

      } else {
        return null;
      }
    }
    else {
      return null;
    }
  }

  process(selected: clients, len) {
    //console.log(selected);
    //return 1;
     if (selected && this.count < len && this.allowRun) {
      this.currentProcessing = selected.name;
      //console.log(this.currentProcessing +"Starting yes");
       this.processSer.processClient(this.appp, selected.clientID, selected.originalClientCode)
         .then((r: any) => {
           //if (r.Success == true || r.success == true ) {
             if (r?.message !== this.processSer.meessageOfSuccess) {
               selected.errorMsgProcess = r.Message;
             } else {
               selected.errorMsgProcess = '';
             }
             this.loadNewresult({ clientID: selected.clientID, success:true, msg: r?.Message || r.message, client: selected.name, VisualisationFileName: this.visualFIlenameExtractor(r), verbose: selected.verbose })
            this.done.push(selected);
            this.count += 1;
             this.percent = this.percentage(this.count, len);
            //console.log(selected.name + " " + "Done");
            this.open_result(this.count, len);
            this.process(this.selectedClie[this.count], len);
          // } else {
          //   selected.errorMsgProcess = r.Message
          //   this.loadNewresult({ clientID: selected.clientID, success: this.decideSuccess('success', r), msg: r?.Message || r.message, client: selected.name, VisualisationFileName: this.visualFIlenameExtractor(r), verbose: selected.verbose  })
          //  this.failed.push(selected);
          //  this.count += 1;
          //  this.percent = this.percentage(this.count, len);

          //  //console.log(selected.name + " " + "Loss");
          //  this.open_result(this.count, len);
          //  this.process(this.selectedClie[this.count], len);
          //}
         }).catch((err) => {
           //if (err?.error?.Success == true || err?.error?.success == true) {
           //  this.done.push(selected);
           //  this.count += 1;
           //  this.loadNewresult({ clientID: selected.clientID, success: this.decideSuccess('error', err), msg: err?.error?.Message || err?.error?.message, client: selected.name, VisualisationFileName: this.visualFIlenameExtractor(err?.error), verbose: selected.verbose })
           //  this.percent = this.percentage(this.count, len);
           //  //console.log(selected.name + " " + "Done");
           //  this.open_result(this.count, len);
           //  this.process(this.selectedClie[this.count], len);
           //} else {
             selected.errorMsgProcess = err?.error?.Message;
             this.failed.push(selected);
             this.count += 1;
             this.percent = this.percentage(this.count, len);
             this.loadNewresult({ clientID: selected.clientID, success: false, msg: err?.error?.Message || err?.error?.message, client: selected.name, VisualisationFileName: this.visualFIlenameExtractor(err?.error), verbose: selected.verbose })
             //console.log(selected.name + " " + "Loss");
             this.open_result(this.count, len);
             this.process(this.selectedClie[this.count], len);
           //}

         })
       setTimeout(() => {
         this.processSer.fetchInprocess.emit();
       },2000)

    }
  }
  percentage(partialValue, totalValue) {
    return (100 * partialValue) / totalValue;
  }

  addClientTOResult(cl: clients) {
    let presentAt: number = 0;
    let present: boolean = false;
    this.resultData.forEach((e, i) => {
      if (e.clientID == cl.clientID) {
        presentAt = i;
        present = true;
      }
    })
    if (present) {
      this.resultData[presentAt].success = false;
      this.resultData[presentAt].msg = 'In-Progress';
    } else {
      this.resultData.push({ success: false, client: cl.name, clientID: cl.clientID, msg: 'In-Progress', VisualisationFileName: null, verbose: cl.verbose })
    }
  }
  clearList(e) {
    this.resultData = [];
  }
  processSelected() {
    this.allowRun = true;
    let lentt = this.selectedClie.length;

    if (lentt > 0) {
    this.selectedClie.forEach((e: clients) => {
      this.addClientTOResult(e)
    })
    this.processSer.fetchNewRes.emit(true);
   
      this.disable = true;
      this.process(this.selectedClie[0], lentt);
      //this.scrollToBottom();
    }
  }
  scrollToBottom() {
    this.processSer.fetchNewRes.emit(true);

  }
  fetch_clients(ap) {
    this.processSer.getClientes(ap).subscribe(
      (res: any) => {
        this.clients = res;
      },
      (err) => {
      }
    );
  }
  constructor(
    private route: ActivatedRoute,
    private processSer: ProcessRunService,
    private dig: MatDialog
  ) {

    route.params.subscribe((s) => {
      this.appp = s["app"];
       this.fetch_clients(this.appp);
    });
  }
  ngOnInit(): void {
  }
  ngAfterViewInit() {
    this.processSer.fetchInprocess.emit();
  }

  findObj(arr: any[], obj) {
    let ans = null;
    arr.forEach((s, i) => {
      if (s.clientID == obj.clientID) {
        ans = i;
        return 1;
      }
    });

    return ans;
  }
  add(cl: any) {
    if (!this.disable) {
      let ind = this.findObj(this.clients, cl);

      if (ind || ind == 0) {
        this.clients.splice(ind, 1);
        this.selectedClie.push(cl);
      }
    }
  }
  rem(cl: any) {
    if (!this.disable) {
    let ind = this.findObj(this.selectedClie, cl);
    if (ind || ind == 0) {
      this.selectedClie.splice(ind, 1);
      this.clients.push(cl);
      }
      }
  }

  open_result(count, len) {
    if (count == len) {
     this.disable=false;
     this.count=0
      this.currentProcessing = "";
      this.percent = 0;
      this.allowRun = false;
      this.processSer.fetchInprocess.emit();
      this.done = [];
      this.failed = [];
      this.fetch_clients(this.appp);
      this.selectedClie = [];
    }
  }
}
